export const ANTD_LOCALE_MAP: Record<string, string> = {
  ar: 'ar_EG',
  'zh-cn': 'zh_CN',
  'zh-tw': 'zh_TW',
  da: 'da_DK',
  nl: 'nl_NL',
  en: 'en_US',
  fi: 'fi_FI',
  fr: 'fr_FR',
  de: 'de_DE',
  el: 'el_GR',
  hi: 'hi_IN',
  hu: 'hu_HU',
  id: 'id_ID',
  it: 'it_IT',
  ja: 'ja_JP',
  ko: 'ko_KR',
  lt: 'lt_LT',
  no: 'nb_NO',
  pl: 'pl_PL',
  pt: 'pt_PT',
  ru: 'ru_RU',
  ro: 'ro_RO',
  es: 'es_ES',
  sv: 'sv_SE',
  th: 'th_TH',
  tr: 'tr_TR',
  vi: 'vi_VN',
  cs: 'cs_CZ',
  hr: 'hr_HR',
  'es-AR': 'es_ES',
  'es-CO': 'es_ES',
  'es-MX': 'es_ES',
  'pt-BR': 'pt_BR',
  'fr-CA': 'fr_FR',
};
